import React from 'react';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import HeaderBanner from '../../../common/HeaderBanner';
import { formatAmount, formatDate } from '../../../../utils/common';
import { getWishlistedAuctions } from './services/auctionService';

export class AuctionWishlist extends React.Component {
  constructor() {
    super();
    this.state = {
      auctions: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);

    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ page, limit }, () => {
      this.wishlistedAuctions();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async wishlistedAuctions() {
    this.setState({ isloading: true });
    let { limit, page } = this.state;
    const q = {
      page: page,
      limit: limit,
    };

    // Update URL
    this.updateUrlQuery(q);

    let response = await getWishlistedAuctions(q);
    if (response.success) {
      let auctions = response.data;
      let { total } = response.meta;

      this.setState({
        auctions,
        total,
        isloading: false,
      });
    }
    this.setState({ isloading: false });
  }

  getColumns = () => {
    const isArabic = i18n.language === 'ar';
    return [
      {
        name: 'Sl No',
        width: '90px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },

      {
        name: 'ID',
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => (
          <span className="highlight-table-value">MZAD {row.auction_relation?.id}</span>
        ),
      },
      {
        name: i18n.t('auction_name'),
        minWidth: '180px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">
            {isArabic ? row.auction_relation.title_ar : row.auction_relation.title}
          </span>
        ),
      },
      {
        name: i18n.t('client'),
        minWidth: '150px',
        cell: (row) =>
          isArabic
            ? row.auction_relation.organization_relation.organization_name_ar
            : row.auction_relation.organization_relation.organization_name,
      },
      {
        name: i18n.t('start_date'),
        width: '120px',
        cell: (row) => (
          <span className="highlight-table-value">
            {formatDate(row.auction_relation.start_date)}
          </span>
        ),
        wrap: true,
      },
      {
        name: i18n.t('end_date'),
        width: '120px',
        cell: (row) => (
          <span className="highlight-table-value">{formatDate(row.auction_relation.end_date)}</span>
        ),
        wrap: true,
      },
      {
        name: i18n.t('start_amount'),
        width: '130px',
        cell: (row) => (
          <span className="highlight-table-value">
            {formatAmount(row.auction_relation.start_amount)}
          </span>
        ),
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('current_amount'),
        width: '130px',
        cell: (row) => {
          const latestBid = row.auction_relation?.latest_bid?.bid_amount;
          const startAmount = row.auction_relation?.start_amount;
          const currentAmount = latestBid ?? startAmount;

          return (
            <span className="highlight-table-value">
              {currentAmount ? formatAmount(currentAmount) : '--'}
            </span>
          );
        },
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('bid_count'),
        width: '130px',
        cell: (row) => (
          <span className="highlight-table-value">{row.auction_relation.total_bid_count}</span>
        ),
        wrap: true,
        center: true,
      },
    ];
  };

  handleRowClick = (row) => {
    const auctionId = row.auction_relation?.id;
    if (auctionId) {
      //   this.props.history.push(`/auction-details/${auctionId}`);
      // OR using window.location if not using React Router
      window.location.href = `/auction-details/${auctionId}`;
    }
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.myBids();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.myBids();
    });
  };

  render() {
    const { auctions } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('wishlisted_auction')}
          subtitle={i18n.t('wishlisted_auctions_subtitle')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="Data-Listing">
                      {this.state.isloading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : this.state.auctions.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={auctions}
                          customStyles={tableStyles}
                          highlightOnHover
                          pointerOnHover
                          onRowClicked={this.handleRowClick}
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_auctions_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.wishlistedAuctions.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
